import styled from 'styled-components'
import {
  textStyleSizeOptions,
  textStyleSizeStyleOptions,
  textStyleWeightOptions,
  textStyleWeightStyleOptions
} from '../stories/fundamentals/text-styles/constants'

export const ErrorMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const ErrorMessage = styled.span`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]}
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
`

export const ErrorDescriptionContainer = styled.span`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  max-height: 300px;
  overflow: auto;
  white-space: pre-wrap;
`

export const ErrorStack = styled.span`
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
`
